export default "/images/facebook-footer.png?f0ad38454ec8c247749707a416d59e9c";